<template>
    <a-spin :spinning="loading">
    <a-button class="m-t-10 m-b-20" v-has:wxAudioAdd="()=>{fileList=[];file=null;addVisible=true;}" type="primary">添加音频</a-button>
    <div class="m-t-25 s_bor_cbed s_bor10 s_over_h s_borList" v-if='list.length > 0'>
      <div class="s_flex" style="background:#83c8dd;line-height:50px;padding-left:30px;color:#fff;fontsize:15px">
        <div style="width:40%">音频信息</div>
        <div style="width:47%">上传时间</div>
        <div style="width:13%">操作</div>
      </div>
      <div class="p-t-15 p-b-15 p-l-20 p-r-20 s_flex_bian_c s_bb1 s_borListItem" v-for='item in list' :key='item.id'>
        <div class="width40 s_flex_ali">
          <img class="width-100 height-100 m-r-20" :src="defaultImg" alt="">
          <p class="s_c333 s_omit width30">{{item.name || '无'}}</p>
        </div>
        <p class="s_c999 flex_1">{{item.create_time}}</p>
        <div class="width15 s_flex_bian_c">
          <a class="flex_1" style="text-align:center" href="javascript:;" v-has:wxAudioEdit="()=>edit(item)">编辑</a>
          <a class="flex_1" style="text-align:center" href="javascript:;" v-has:wxAudioDel="()=>del(item)">删除</a>
        </div>
      </div>
    </div>
    <div v-if="list.length==0" class='p-50'>
      <a-empty :description="false" />
    </div>
  </a-spin>
   <a-pagination :style="{marginTop:'25px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  <a-modal  :keyboard="false" title="编辑音频" :width='500' centered :footer="null" v-model:visible="visible" destroyOnClose>
    <a-form ref='form'>
     <a-form-item label="标题">
      <a-input v-model:value="audioData.name" style="width:300px" placeholder="请输入音频标题" maxlength="30" />
      <span class="m-l-10">{{audioData.name.length || 0}} / 30</span>
    </a-form-item>
    </a-form>
    <div style=" text-align: center;">
        <a-button type="primary" style="display:inline-block" @click="submit">保存</a-button>
    </div>
  </a-modal>
   <!-- 添加音频 -->
   <a-modal  :keyboard="false" title="添加音频" :width='500' centered :footer="null" v-model:visible="addVisible" destroyOnClose>
    <a-form ref='form'>
     <a-form-item label="音频" required>
       <span class="m-r-10" v-if="fileList[0]"><CustomerServiceOutlined class="m-r-5"/>{{fileList[0]?fileList[0].name:'无'}}</span>
      <a-upload :show-upload-list="false" accept="audio/mpeg"  :before-upload="handleChange" v-model:file-list="fileList">
        <a-button>
        <CloudUploadOutlined />{{fileList[0]?'重新上传':'上传'}}
        </a-button>
      </a-upload>
      <br>
      <span class="fz-12 s_c999" >格式支持mp3、wma、wav、amr、m4a，文件大小不超过2M，音频时长不超过2小时。 上传后音频将提交微信公众平台进行转码和审核</span>
     </a-form-item>
     <a-form-item label="标题">
        <a-input v-model:value="audioName" placeholder="请输入音频标题" maxlength="30" style="width:300px"/>
        <span class="m-l-5 s_c999">{{audioName.length || 0}} / 30</span>
     </a-form-item>
     <a-form-item style="padding-left:45px;padding-top:20px">
        <a-button type="primary"  @click="addSubmit">提交</a-button>
     </a-form-item>
    </a-form>
   
  </a-modal>

</template>

<script>
import {wxMaterialVoice,editWxMaterialVoice,delWxMaterialVoice,uploadWxMaterialVoice} from '@/api/public_wx'
import { message } from "ant-design-vue";
import { iscode } from "@/utils/app";
import {CustomerServiceOutlined,CloudUploadOutlined} from '@ant-design/icons-vue';
import { reactive,toRefs,ref, onMounted,inject } from 'vue';
import { json2fromData } from "@/utils/utils";
let defSearch = {
  page: 1,
  limit: 10,
  keyword: "",
};

export default{
  components:{
    CustomerServiceOutlined,
    CloudUploadOutlined
  },
    setup(){
        const $Modal = inject("$Modal");
      const search = ref({ ...defSearch });
      const state = reactive({
           loading:false,
           defaultImg:require('@/assets/images/audio.png'),
           list:[{id:1},{id:2}],
           total: 1,
           visible:false,
           addVisible:false,
           audioData:{name:''},
           fileList:[],
           file:null,
           audioName:''
      })

      const methods = {
           //选择文件
         handleChange(file){
            state.fileList = file;
            state.file = file;
            return false;
          },
         async initData(values){
             state.loading = true;
             let res = await wxMaterialVoice(values).then((res) => res.data);
             state.loading = false;
             if (iscode(res)) {
               state.list = res.data.data;
               state.total = res.data.total;
             }
         },
         edit(item){
             state.audioData = JSON.parse(JSON.stringify(item)) || {}
             state.visible = true;
         },
         del(item){
           $Modal.confirm({
                  centered: true,
                  content: "删除后该音频将无法恢复，您确定要删除该音频吗？",
                  onOk: async () => {
                    let res = await delWxMaterialVoice({ id: item.id }).then((res) => res.data);
                    if (iscode(res, true)) {
                      methods.initData(search.value);
                    }
                  },
                });
         },

         // 分页当前页切换
        pageCurrentChange(page, pageSize){
           search.value.page = page;
           methods.initData(search.value);
         },
         // 分页当前页显示多少条切换
         pageSizeChange(current, limit){
           search.value.page = 1;
           search.value.limit = limit;
           methods.initData(search.value);
         },
        async submit(){
              let res = await editWxMaterialVoice({id:state.audioData.id,name:state.audioData.name}).then(res=>res.data)
               if (iscode(res,true)) {
                   methods.initData(search.value)
                   state.visible = false;
               }
         },
        async addSubmit(){

            if(!state.file) return  message.error('请重新上传音频！');
            let size = (state.file.size / 1024) / 1000;
             if(size > 2) return message.error('上传音频不能超过2M！');
            let type = state.file.type.substring(0,state.file.type.indexOf('/'))
            if(type!='audio') return message.error('上传音频格式不正确！'); 
             const hide = message.loading("正在加载中...", 0);
            //  console.log(state.file,'222')
            //  let blob = new Blob([state.file],  {type: 'Blob'});
            var formData = json2fromData({file:state.file,name:state.audioName});
            let res = await uploadWxMaterialVoice(formData).then(res=>res.data);
            if (iscode(res,true)) {
                   methods.initData(search.value)
                   state.addVisible = false;
               }
                 setTimeout(hide);
         }
      }
      
      onMounted(()=>{
           methods.initData(search.value)
      })
      return{
          ...toRefs(state),
          ...methods,
          search
          
      }
    }
}
</script>
